var _desc, _rect, _rect2, _path, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeoSignalsMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "SEO Signals mark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Three stepped signal blocks forming an abstract S and forward arrow.")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 20,
    fill: "#141616"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 18,
    width: 56,
    height: 16,
    rx: 8,
    fill: "#C8FF3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 40H68L84 48L68 56H28C23.6 56 20 52.4 20 48S23.6 40 28 40Z",
    fill: "#C8FF3D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 62,
    width: 56,
    height: 16,
    rx: 8,
    fill: "#C8FF3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeoSignalsMark);
export default __webpack_public_path__ + "static/media/seo-signals-mark.b84bda1cde203ed27ee0b28bd5d6227b.svg";
export { ForwardRef as ReactComponent };